export default __webpack_public_path__ + "static/media/linkedin.30f26f60.svg";